// The dashboard's on/off switch: a rounded track, green when on.
export default function Switch({ checked, onChange, label, disabled = false, id = undefined }) {
    return (
        <button
            id={id}
            type="button"
            role="switch"
            aria-checked={checked}
            aria-label={label}
            disabled={disabled}
            onClick={() => onChange(!checked)}
            className={`relative h-[17px] w-[30px] shrink-0 cursor-pointer rounded-full transition-colors disabled:cursor-not-allowed disabled:opacity-50 motion-reduce:transition-none ${checked ? "bg-[color:var(--green)]" : "bg-[color:var(--line-strong)]"}`}
        >
            <span aria-hidden="true" className={`absolute top-[2px] h-[13px] w-[13px] rounded-full bg-[color:var(--bg)] transition-[left] motion-reduce:transition-none ${checked ? "left-[15px]" : "left-[2px]"}`} />
        </button>
    );
}
